import { Container, ExternalLink, Heading, List, LinkText } from 'app/components/start/startStyles';
import FuPaCompanyMetaData from 'app/models/about/FuPaCompanyMetaData';
import React from 'react';
const About = () => {
  return /*#__PURE__*/React.createElement(Container, {
    "data-sentry-element": "Container",
    "data-sentry-component": "About",
    "data-sentry-source-file": "About.tsx"
  }, /*#__PURE__*/React.createElement(Heading, {
    variant: "subheading2",
    component: "span",
    "data-sentry-element": "Heading",
    "data-sentry-source-file": "About.tsx"
  }, "\xDCber uns"), /*#__PURE__*/React.createElement(List, {
    "data-sentry-element": "List",
    "data-sentry-source-file": "About.tsx"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ExternalLink, {
    href: FuPaCompanyMetaData.JobPageLink,
    target: "_blank",
    "data-sentry-element": "ExternalLink",
    "data-sentry-source-file": "About.tsx"
  }, /*#__PURE__*/React.createElement(LinkText, {
    variant: "subheading",
    "data-sentry-element": "LinkText",
    "data-sentry-source-file": "About.tsx"
  }, "Jobs"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ExternalLink, {
    href: "https://support.fupa.net/support/tickets/new",
    target: "_blank",
    "data-sentry-element": "ExternalLink",
    "data-sentry-source-file": "About.tsx"
  }, /*#__PURE__*/React.createElement(LinkText, {
    variant: "subheading",
    "data-sentry-element": "LinkText",
    "data-sentry-source-file": "About.tsx"
  }, "Kontakt")))));
};
export { About };